import { useMutation } from '@tanstack/react-query'
import { purchaseTicket } from '../../service/list'

function usePurchaseVoiceTicket() {
  return useMutation({
    mutationKey: ['purchase-voice-ticket'],
    mutationFn: purchaseTicket,
  })
}

export default usePurchaseVoiceTicket
